import { render } from "./TicketTabsBar.vue?vue&type=template&id=66b704b6&scoped=true"
import script from "./TicketTabsBar.vue?vue&type=script&lang=js"
export * from "./TicketTabsBar.vue?vue&type=script&lang=js"

import "./TicketTabsBar.vue?vue&type=style&index=0&id=66b704b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b704b6"]])

export default __exports__